import React from 'react'
import './Newcollections.css'
import new_collection from '../Assets/new_collections'
import Item from '../Items/Item'

function Newcollections() {
  return (
    <div className='new-collections'>
        <h1>New Collection</h1>
        <hr />
        <div className="collections">
            {new_collection.map((item,i) => { return <div className="item">
                <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
            </div>
            })}
             
        </div>
      
    </div>
  )
}

export default Newcollections
